// src/utils/localStorageUtil.ts

/**
 * Sets a value for a key in localStorage
 * @param key The key under which to store the value.
 * @param value The value to store. It will be stringified.
 */
export const setLocalStorageItem = (key: string, value: any): void => {
  const stringValue = JSON.stringify(value);
  localStorage.setItem(key, stringValue);
};

/**
 * Retrieves a value from localStorage
 * @param key The key of the item to retrieve.
 * @returns The parsed value stored under the key, or null if not found.
 */
export const getLocalStorageItem = <T>(key: string): T | null => {
  const item = localStorage.getItem(key);
  if (!item) return null;
  return JSON.parse(item) as T;
};

/**
 * Removes an item from localStorage
 * @param key The key of the item to remove.
 */
export const removeLocalStorageItem = (key: string): void => {
  localStorage.removeItem(key);
};

// ✅ For expirable data
export const setExpirableItem = (key: string, value: any, expiryInMs: number) => {
  const data = {
    value,
    expiresAt: Date.now() + expiryInMs,
  };
  localStorage.setItem(key, JSON.stringify(data));
};

export const getExpirableItem = <T>(key: string): T | null => {
  const item = localStorage.getItem(key);
  if (!item) return null;

  const parsed = JSON.parse(item);
  if (parsed.expiresAt && parsed.expiresAt < Date.now()) {
    localStorage.removeItem(key);
    return null;
  }
  return parsed.value as T;
};
